import { isNil } from 'lodash-es';
import { localDateToLocalWeek } from '../week/week-picker-calculations';
import { localDateFromUTCDate } from './date-types';
export function getYear(date) {
    return date ? date[0] : undefined;
}
export function getMonth(date) {
    return date ? [date[0], date[1]] : undefined;
}
export const JS_MONDAY = 1;
export const JS_THURSDAY = 4;
export function monthView(pageYear, pageMonth, weekNumber) {
    // Fix JavaScript's Date.UTC bug: years 0-99 are interpreted as 1900-1999
    // Use a safe year first, then set the correct year with setUTCFullYear
    const date = new Date(Date.UTC(2000, pageMonth - 1, 1));
    date.setUTCFullYear(pageYear, pageMonth - 1, 1);
    if (isNil(date) || isNaN(date.getMilliseconds())) {
        console.error('year and/or month values are invalid', pageYear, pageMonth);
        return [];
    }
    while (date.getUTCDay() !== JS_MONDAY) {
        date.setUTCDate(date.getUTCDate() - 1);
    }
    const result = [];
    for (let i = 0; i < 6; i++) {
        const days = [];
        const localDate = localDateFromUTCDate(date);
        const week = weekNumber ? localDateToLocalWeek(localDate) : undefined;
        for (let j = 0; j < 7; j++) {
            days.push(localDateFromUTCDate(date));
            date.setUTCDate(date.getUTCDate() + 1);
        }
        result.push({ week, days });
    }
    return result;
}
